import type { Config } from "@puckeditor/core";
import { contentBlocks } from "@/puck/blocks/contentBlocks";
import { templateConfigs } from "@/puck/blocks/content/templateConfigs";
import { marketingBlocks } from "@/puck/blocks/marketingBlocks";
import { createImportStructureConfig } from "@/puck/blocks/shared/importStructureConfig";
import { applyAnchorsToComponents } from "@/puck/fields/anchorField";
import type { LandingPageComponents, LandingRootProps } from "@/puck/types";

const puckConfig: Config<LandingPageComponents, LandingRootProps> = {
  root: {
    fields: {
      title: { type: "text", label: "Internal title" },
    },
    render: ({ children }) => <main className="bg-marketing-surface">{children}</main>,
  },
  categories: {
    structure: {
      title: "Structure",
      components: ["Header", "Footer", "ImportStructure"],
      defaultExpanded: true,
    },
    content: {
      title: "Content",
      components: [
        "Hero",
        "FeatureStrip",
        "Logos",
        "Workflows",
        "Outcomes",
        "BuyerQuote",
        "FAQ",
        "RichText",
        "WistiaVideo",
        "PartnerTicker",
        "BookDemo",
        "Snippet",
        "Image",
        "Columns",
        "ChatMockup",
        "ChartMockup",
        "Card",
        "SectionHeading",
        "PhoneVideo",
        "NumberedSteps",
        "FloatingBadge",
        "GptPageMockup",
      ],
      defaultExpanded: false,
    },
    referenceSections: {
      title: "Marketing page sections",
      components: [
        "LpHero",
        "LpGptHero",
        "LpFeatureStrip",
        "LpReframe",
        "LpHowItWorks",
        "LpWorkflows",
        "LpOneGail",
        "LpIntegrations",
        "LpOutcomes",
        "LpBuyerQuote",
        "LpHonestFilter",
        "LpFaq",
        "LpBookDemo",
        "LpGptBottomCta",
        "LpGptPageMockup",
        "LpAiModels",
        "LpFooter",
      ],
      defaultExpanded: true,
    },
    studioTemplates: {
      title: "Templates",
      components: [
        "TemplateBusywork",
        "TemplateUploadExperts",
        "TemplateFilledWhileYouWatch",
      ],
      visible: false,
    },
  },
  components: applyAnchorsToComponents({
    ...contentBlocks,
    ...marketingBlocks,
    ...templateConfigs,
    ImportStructure: createImportStructureConfig("landing"),
  }),
};

export default puckConfig;
